import React from "react";
import { MapContainer, TileLayer, GeoJSON } from "react-leaflet";
import { Box, Grid } from "@mui/material";
import mapLayers from "./map_test.json";
import CenterLayout from "../../components/CenterLayout";

export default function Map() {
    return (
        <CenterLayout>
            <h1>Festivalkart</h1>
            <MapContainer
                center={[59.5466, 9.09348]}
                zoom={16}
                scrollWheelZoom={false}
                style={{
                    height: 400,
                    width: "100%"
                }}
            >
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <GeoJSON
                    data={mapLayers}
                    style={(feature) => {
                        return {
                            fillColor: feature.properties.fill,
                            color: feature.properties.stroke,
                            weight: feature.properties["stroke-width"],
                            fillOpacity: feature.properties["fill-opacity"],
                        };
                    }}
                />
            </MapContainer>
            <Grid
                container
                spacing={2}
                direction="row"
                justifyContent="center"
            >
                {mapLayers.features
                    .filter(
                        (feature) =>
                            feature.properties.label &&
                            feature.properties.label !== ""
                    )
                    .map((feature, index) => (
                        <Grid
                            item
                            key={index}
                            sx={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                            }}
                        >
                            <Box
                                sx={{
                                    height: 16,
                                    width: 16,
                                    backgroundColor:
                                        feature.properties.fill ||
                                        feature.properties.stroke,
                                    border:
                                        "2px solid " +
                                        feature.properties.stroke,
                                }}
                            />
                            {feature.properties.label}
                        </Grid>
                    ))}
            </Grid>
        </CenterLayout>
    );
}
